<style lang="scss" scoped>
.static-banner {
    position: relative;
    width: 100%;
    height: 360px;

    &:after {
        content: "";
        z-index: 1;
        top: 0;
        left: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(
            225deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.5) 100%
        );

        @media (min-width: 768px) {
            border-radius: 8px;
        }
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        font-family: "object-fit: cover;";

        @media (min-width: 768px) {
            border-radius: 8px;
        }
    }

    .content {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        display: flex;
        flex-flow: column;
        justify-content: center;
        padding: 0 24px;

        @media (min-width: 1024px) {
            padding: 0 40px;
        }

        .title {
            white-space: nowrap;
            line-height: 1;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .description {
            max-width: 350px;
        }
    }
}
</style>

<template>
    <div class="container">
        <div class="mb-40 d-flex flex-wrap w-100" v-if="title">
            <h3 class="title" v-html="title"></h3>
            <a v-if="generatedCtaLink" :href="generatedCtaLink" class="ml-auto my-auto link-arrow">{{ cta }} <span class="arrow-right" v-html="svg('arrow-right')" /></a>
        </div>
        <component :is="staticItemInterface.cta_kind && linkIsValid ? 'a': 'div'" class="d-block position-relative" :href="staticItemInterface.cta_kind && linkIsValid ? (staticItemInterface.cta_kind === 'link' ? `/${staticItemInterface.cta_link}` : route('nl.category',  {'slug': staticItemInterface.cta_category.slug})) : null">
            <div class="mx-n24 mx-md-0">
                <div class="static-banner">
                    <img v-if="staticItemInterface.image" :src="staticItemInterface.image.url" :alt="staticItemInterface.title">
                    <div class="content">
                        <h3 v-if="staticItemInterface.title" class="mb-8 text-white title">{{ staticItemInterface.title }}</h3>
                        <p v-if="staticItemInterface.description" class="small text-white font-weight-book description">
                            {{ staticItemInterface.description }}
                        </p>
                        <button v-if="staticItemInterface.cta_kind != null && staticItemInterface.cta_kind != '' && linkIsValid" class="btn btn-accent mt-16 align-self-start" :href="staticItemInterface.cta_kind === 'link' ? `/${staticItemInterface.cta_link}` : route('nl.category',  {'slug': staticItemInterface.cta_category.slug})">{{ staticItemInterface.cta }} <span v-html="svg('arrow-right', 'arrow-right')" /></button>
                    </div>
                </div>
            </div>
        </component>
    </div>
</template>

<script>
import hasCta from "../mixins/has-cta";

export default {
    name: "pagePart.static-content-banner-row",

    mixins: [hasCta],

    props: {
        title: {
            type: String,
            required: false,
        },
        staticItem: {
            type: Object,
            required: false,
            default: () => {
                return {
                    title: '',
                    description: '',
                    image: '',
                    tags: [],
                    media: [],
                    link: ''
                };
            },
        },
        src: {
            type: String,
            required: false,
            default: '',
        },
        alt: {
            type: String,
            required: false,
            default: 'Inspire Your Tribe',
        },
        categoryFilterId: {
            type: Number,
            default: null,
        },
        pages: {
            type: Array,
            required: false,
            default: null
        },
    },

    computed: {
        staticItemInterface() {
            if (this.staticItem.ID != null) {
                let intfc = this.staticItem.acf;
                intfc.cta_kind = intfc.cta_type;
                intfc.title = this.staticItem.post_title;
                intfc.id = this.staticItem.id;

                if (intfc.cta_type == 'category') {
                    let filteredCategory = this.pages.filter(p => p.id == this.staticItem.acf.cta_category[0]);
                    if (filteredCategory.length > 0) {
                        let slug = filteredCategory[0].slug;
                        intfc.cta_category = {
                            slug: slug
                        };
                    }
                } else {
                    intfc.cta_category = {
                        slug: ''
                    };
                }

                return intfc;
            }
            return this.staticItem;
        },

        linkIsValid() {
            let intfc = this.staticItemInterface;

            if (intfc.cta_kind === 'category' && intfc.cta_category && intfc.cta_category.slug != '') {
                return true;
            }

            if (intfc.cta_kind === 'link' && intfc.cta_link != '') {
                return true;
            }

            return false;
        },
    }
}
</script>